module.exports = __webpack_public_path__ + "static/ndcoslo2018-c2d28787178fdb0eb5b10dd1bbe9073f.png";